var VRC = VRC || {};
VRC.ContainerPopoverView = (function () {

	var init = function ($containerDom, container, config) {
		$('.deckstate_container').popover('destroy');

		var jsonElement = container.toJson ? container.toJson() : container;

		var dg = [];
		if (jsonElement.dg_class) {
			dg = _.map(jsonElement.dg_class.split(','), function (dgClassId) {
				return VRC.MasterDataService.getDgClass(dgClassId).name;
			});
			jsonElement.dg = dg;
		}

		var popOverHtml = WELL.Handlebars.VRC.containerPopover(jsonElement);

		$containerDom.attr('data-content', popOverHtml);
		$containerDom.popover({animation : false, html: true, placement: 'bottom auto', title: config.title, sanitize: false });
		$containerDom.popover('show');

		$('.popover').find('.close').click(function (e) {
			e.preventDefault();
			hide();
		});

	};

	var show = function ($dropzoneElement, droppedElement, onConfirm, onCancel, config) {
		config = config || {};
		init($dropzoneElement, droppedElement, config);

		var $popover = $dropzoneElement.next();

	};

	var hide = function ($containerDom) {
		$('.deckstate_container').popover('destroy');
	};
	return {
		show: show,
		hide: hide
	}
})();